<template>
  <div class="travelsearch">
    <div class="search-box">
      <div class="input-box">
        <img src="../../assets/travelAgency/ic_search.png" alt class="search-icon" />
        <input
          style
          type="text"
          placeholder="搜索旅行社名称或者统一社会信用代码"
          class="search-input"
          v-model="inputValue"
          @input="onInputChange"
          @blur="onInputBlur"
        />
      </div>
      <div class="search-btn" @click="$router.go(-1)">取消</div>
    </div>
    <div class="latest-box" v-if="latestList.length > 0">
      <div class="title-box">
        <div class="title">最近搜索</div>
        <img
          src="../../assets/travelAgency/ic_delete.png"
          alt
          class="delete-icon"
          @click="latestDelete"
        />
      </div>
      <div class="tags-box">
        <div
          class="tag"
          v-for="(lists,index) in latestList"
          :key="index"
          @click="onSearchByTag(lists)"
        >
          <div class="label">{{lists}}</div>
        </div>
      </div>
      <div class="tags-real-box">
        <div
          class="tag"
          v-for="(lists,index) in latestList"
          :key="index"
        >{{lists}}</div>
      </div>
    </div>
    <div class="history-box" v-if="inputValue == '' && listData.length > 0">
      <div class="title-box">
        <div class="title">浏览历史</div>
        <img
          src="../../assets/travelAgency/ic_delete.png"
          alt
          class="delete-icon"
          @click="historyDelete"
        />
      </div>
      <div class="lists-box">
        <div
           v-for="(items,index) in listData"
          :key="index"
          @click="$router.push({ path: '/travelAgency/info', query: { id: items.id } })">
        <div
          class="items-box"
        >
          <img :src="items.photoPath" alt class="agency-img" v-if="items.photoPath" />
          <img src="../../assets/travelAgency/ic_Bitmap.png" alt class="agency-img" v-else/>
          <div class="info-box">
            <div class="company-name">{{items.name}}</div>
            <div class="tag-box">
                  <!-- <txtTag class="tag" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">{{items.isParent == 1 ? '总社' : '分社'}}</txtTag>
                  <txtTag class="tag" v-if="!items.area" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">其他地区</txtTag>
                  <txtTag
                    class="tag"
                    v-for="(areaItem,idx) in cityAllList"
                    :key="idx"
                    :bgColor="'#fff'"
                    :border="'#36B374'"
                    :txtColor="'#36B374'"
                    v-show="cityAllList.area && areaItem.value == cityAllList.area"
                  >{{areaItem.content}}</txtTag>
                   <txtTag :bgColor="'#FF8C19'" :border="'#FF8C19'" :txtColor="'#fff'"  v-if="items.isSupervise != 0">重点关注中</txtTag>
                   <txtTag :bgColor="'#FF4D4D'" :border="'#FF4D4D'" :txtColor="'#fff'" v-if="items.isBlacklist != 0">黑名单</txtTag> -->
                    <smllabel class="tag" :bgColor="'#fff'" :borderColor="'#36B374'" :txtColor="'#36B374'" >{{items.isParent == 1 ? '总社' : '分社'}}</smllabel>
                    <smllabel class="tag" v-if="!items.area" :bgColor="'#fff'" :borderColor="'#36B374'" :txtColor="'#36B374'" >其他地区</smllabel>
                    <smllabel
                      class="tag"
                      v-for="(areaItem,idx) in cityAllList"
                      :key="idx"
                      :bgColor="'#fff'"
                      :borderColor="'#36B374'"
                      :txtColor="'#36B374'"

                      v-show="items.area && areaItem.VALUE == items.area"
                    >{{areaItem.short_name}}&nbsp;{{areaItem.content}}</smllabel>

            </div>
            <div class="tag-box">
              <smllabel :bgColor="'#FF8C19'" :borderColor="'#FF8C19'" :txtColor="'#fff'"  v-if="items.isSupervise != 0" >重点关注中</smllabel>
              <smllabel :bgColor="'#FF4D4D'" :borderColor="'#FF4D4D'" :txtColor="'#fff'" v-if="items.isBlacklist != 0">黑名单</smllabel>
            </div>
            <!-- <div class="prices-box">
              <div class="tags" v-if="items.integrityScore">诚信指数 {{items.integrityScore}}分</div>
              <div class="tags" v-if="items.pointsDeducted">扣分 {{items.pointsDeducted}}次</div>
              <div class="tags" v-if="items.complaintTime">投诉 {{items.complaintTime}}次</div>
            </div> -->
          </div>
        </div>
        <rline v-if="index < listData.length - 1"></rline>
        </div>
      </div>

    </div>
    <div class="result-box" v-if="inputValue != ''">
      <div class="title-box">
        <div class="title">搜索结果</div>
      </div>
      <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="loadMore"
          v-if="listResultData.length > 0"
      >
      <div class="lists-box" v-if="listResultData.length > 0">
          <div
            v-for="(items,index) in listResultData"
            :key="index"
            @click="toDetail(items)">
          <div
            class="items-box"
          >
            <img :src="items.photoPath" alt class="agency-img" v-if="items.photoPath" />
            <img src="../../assets/travelAgency/ic_Bitmap.png" alt class="agency-img" v-else/>
            <div class="info-box">
              <div class="company-name">{{items.name}}</div>
              <div class="tag-box">
                  <!-- <txtTag class="tag" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">{{items.isParent == 1 ? '总社' : '分社'}}</txtTag>
                  <txtTag class="tag" v-if="!items.area" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">其他地区</txtTag>
                  <txtTag
                    class="tag"
                    v-for="(areaItem,idx) in cityAllList"
                    :key="idx"
                    :bgColor="'#fff'"
                    :border="'#36B374'"
                    :txtColor="'#36B374'"
                    v-show="cityAllList.area && areaItem.value == cityAllList.area"
                  >{{areaItem.content}}</txtTag>
                   <txtTag :bgColor="'#FF8C19'" :border="'#FF8C19'" :txtColor="'#fff'"  v-if="items.isSupervise != 0">重点关注中</txtTag>
                   <txtTag :bgColor="'#FF4D4D'" :border="'#FF4D4D'" :txtColor="'#fff'" v-if="items.isBlacklist != 0">黑名单</txtTag> -->
                   <smllabel class="tag" :bgColor="'#fff'" :borderColor="'#36B374'" :txtColor="'#36B374'" >{{items.isParent == 1 ? '总社' : '分社'}}</smllabel>
                    <smllabel class="tag" v-if="!items.area" :bgColor="'#fff'" :borderColor="'#36B374'" :txtColor="'#36B374'" >其他地区</smllabel>
                    <smllabel
                      class="tag"
                      v-for="(areaItem,idx) in cityAllList"
                      :key="idx"
                      :bgColor="'#fff'"
                      :borderColor="'#36B374'"
                      :txtColor="'#36B374'"

                      v-show="items.area && areaItem.VALUE == items.area"
                    >{{areaItem.short_name}}&nbsp;{{areaItem.content}}</smllabel>

              </div>
              <div class="tag-box">
                <smllabel :bgColor="'#FF8C19'" :borderColor="'#FF8C19'" :txtColor="'#fff'"  v-if="items.isSupervise != 0" >重点关注中</smllabel>
                <smllabel :bgColor="'#FF4D4D'" :borderColor="'#FF4D4D'" :txtColor="'#fff'" v-if="items.isBlacklist != 0">黑名单</smllabel>
              </div>
              <!-- <div class="prices-box">
                <div class="tags" v-if="items.integrityScore">诚信指数 {{items.integrityScore}}分</div>
                <div class="tags" v-if="items.pointsDeducted">扣分 {{items.pointsDeducted}}次</div>
                <div class="tags" v-if="items.complaintTime">投诉 {{items.complaintTime}}次</div>
              </div> -->
            </div>
          </div>
          <rline v-if="index < listResultData.length - 1"></rline>
          </div>
      </div>
      </van-list>
      <empty :type="2" v-if="listResultData.length === 0 && !loading"></empty>
    </div>
  </div>
</template>
<script>
    import api from '../../service/modules/travel';
    import empty from 'comps/empty';
    import txtTag from './components/txt-tag'
    import rline from './components/line'
    import smllabel from './components/small-label'
    export default {
        components: {
            empty,
            txtTag,
            rline,
            smllabel
        },

        data () {
            return {
                inputValue: '',
                latestList: [],
                listResultData: [],
                listData: [],
                pagination: { total: 0, current_page: 0, page_size: 0 },
                loading: false,
                finished: false,
                finishedText: '没有更多',
                keyWord: '',
                cityAllList: []
            };
        },

        computed: {},

        watch: {},

        methods: {
            // input失去焦点
            onInputBlur (e) {
                if (e.target.value) {
                    let travelSearchList = localStorage.travelSearchList
                        ? JSON.parse(localStorage.travelSearchList)
                        : [];
                    let keywords = this.inputValue
                    travelSearchList.push(keywords);
                    travelSearchList = Array.from(new Set([...travelSearchList]));
                    localStorage.travelSearchList = JSON.stringify(travelSearchList);
                }
            },
            // 监听input值变化
            onInputChange (e) {
                if (e.target.value) {
                    if (this.keyword === e.target.value) {
                        return false;
                    }
                    this.inputValue = e.target.value
                    this.inputValue = this.inputValue.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
                    this.keyword = this.inputValue
                    this.goSearch()
                }
            },
            // 点击标签直接触发搜索
            onSearchByTag (value) {
                this.inputValue = value
                this.goSearch();
            },
            goSearch () {
                // 先清空之前搜索的数据
                this.listResultData = [];
                this.pagination = { total: 0, current_page: 0, page_size: 0 };
                this.loading = true;
                this.finished = false;
                // 获取搜索的数据
                this.getSearchData();
            },
            // 最近搜索删除
            latestDelete () {
                this.latestList = [];
                localStorage.removeItem('travelSearchList');
            },
            // 历史记录删除
            historyDelete () {
                this.listData = [];
                localStorage.removeItem('travelHistoryList')
            },
            loadMore () {
                this.getSearchData();
            },
            // 跳转详情页
            toDetail (items) {
                // 存储历史记录
                if (localStorage.travelHistoryList) {
                    let travelHistoryList = JSON.parse(localStorage.travelHistoryList)
                    let isExit = false
                    travelHistoryList.map((lists, index) => {
                        if (items.id === lists.id) {
                            isExit = true
                        }
                    })
                    if (!isExit) {
                        if (travelHistoryList.length >= 10) {
                            let newArr = travelHistoryList.filter((val, index, arr) => {
                                return index !== 0;
                            })
                            newArr.push(items)
                            localStorage.travelHistoryList = JSON.stringify(newArr)
                            setTimeout(() => {
                                this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                            }, 300)
                        } else {
                            travelHistoryList.push(items)
                            localStorage.travelHistoryList = JSON.stringify(travelHistoryList)
                            setTimeout(() => {
                                this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                            }, 300)
                        }
                    } else {
                        this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                    }
                } else {
                    let travelHistoryList = []
                    travelHistoryList.push(items)
                    localStorage.travelHistoryList = JSON.stringify(travelHistoryList)
                    setTimeout(() => {
                        this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                    }, 300)
                }
            },
            // 搜索结果
            getSearchData () {
                this.loading = true;
                api
                    .travelList({
                        p: parseInt(this.pagination.current_page) + 1,
                        pageSize: 10,
                        queryPar: this.inputValue,
                        state: 3
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.listResultData = [...this.listResultData, ...res.data.list];
                            this.pagination = res.data.pagination;
                            this.loading = false;
                            if (
                                this.pagination.current_page >=
                                Math.ceil(this.pagination.total / this.pagination.page_size)
                            ) {
                                this.finished = true;
                            }
                        } else {
                            this.$Toast('请输入合法字符');
                        }
                    });
            },
            // 拉取所有市和县的数据
            getTravelCityAll () {
                api.getTravelCityAll().then(res => {
                    if (res.ret === 0) {
                        this.cityAllList = res.data.list
                    }
                })
            }
        },

        mounted () {
            this.getTravelCityAll();
            this.latestList = localStorage.travelSearchList
                ? JSON.parse(localStorage.travelSearchList)
                : [];
            if (this.$route.query.key) {
                this.inputValue = this.$route.query.key
                this.goSearch(this.$route.query.key);
            }
            // 获取缓存里的数据
            if (localStorage.travelHistoryList) {
                this.listData = JSON.parse(localStorage.travelHistoryList);
            }
        },
        created () {}
    };
</script>
<style scoped lang="less">
@vv: 3.75vw;
.travelsearch {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding: 10/@vv 12/@vv 0 12/@vv;
  .search-box {
    height: 28/@vv;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 25/@vv;
    .input-box {
      flex: 1;
      margin-right: 12/@vv;
      height: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-left: 16/@vv;
      background: rgba(245, 245, 245, 1);
      border-radius: 1/@vv;
      .search-icon {
        width: 15/@vv;
        margin-right: 8/@vv;
      }
      input::-webkit-input-placeholder {
        font-size: 12/@vv;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17/@vv;
      }

      .search-input {
        flex: 1;
        background: rgba(245, 245, 245, 1);
      }
    }
    .search-btn {
      width: 40/@vv;
      height: 28/@vv;
      background: rgba(245, 245, 245, 1);
      border-radius: 1/@vv;
      font-size: 12/@vv;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 179, 116, 1);
      line-height: 30/@vv;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .latest-box {
    margin-bottom: 28/@vv;
    overflow: hidden;
    position: relative;

    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12/@vv;

      .title {
        font-size: 16/@vv;
        font-family: PingFang SC,Arial,sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
        line-height: 16/@vv;
      }
      .delete-icon {
        width: 18/@vv;
        height: 18/@vv;
      }
    }
    .tags-box {
      position: absolute;
      z-index: 99;
      top: 30/@vv;
      left: 0;
      width: 732/@vv;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      transform: scale(0.5);
      transform-origin: left 0;
      // background: yellow;

      .tag{
         display: table;
         margin-right: 32/@vv;
         margin-bottom: 20/@vv;
         .label{
            font-size: 24/@vv;
            font-family: PingFangTC-Regular, PingFangTC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 56/@vv;
            box-sizing: border-box;
            padding: 0 16/@vv;
            background: rgba(255, 255, 255, 1);
            border-radius: 2/@vv;
            border: 1/@vv solid rgba(204, 204, 204, 1);
            display: table-cell;
            vertical-align: middle;
         }
      }
    }
    .tags-real-box{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      opacity: 0 ;

      .tag{
        margin-right: 16/@vv;
        margin-bottom: 10/@vv;
        font-size: 12/@vv;
        font-family: PingFangTC-Regular, PingFangTC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 28/@vv;
        box-sizing: border-box;
        padding: 0 8/@vv;
        background: rgba(255, 255, 255, 1);
        border-radius: 1/@vv;
        border: 1/@vv solid rgba(204, 204, 204, 1);
      }
    }
  }
  .history-box,
  .result-box {
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12/@vv;

      .title {
        font-size: 16/@vv;
        font-family: PingFang SC,Arial,sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
        line-height: 16/@vv;
      }
      .delete-icon {
        width: 18/@vv;
        height: 18/@vv;
      }
    }
    .lists-box {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0/@vv 0/@vv 10/@vv 0/@vv rgba(0, 0, 0, 0.04);
      border-radius: 3/@vv;

      .items-box {
        display: flex;
        box-sizing: border-box;
        padding: 16/@vv 0 16/@vv 16/@vv;

        .agency-img {
          width: 84/@vv;
          height: 84/@vv;
          margin-right: 12/@vv;
          object-fit: cover;
        }

        .info-box {
          flex: 1;
          overflow: hidden;

          .company-name {
            font-size: 14/@vv;
            font-family: PingFang SC,Arial,sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            line-height: 20/@vv;
          }

          .tag-box {
            // width: 300/@vv;
            height: 18/@vv;
            display: flex;
            align-items: center;
            // flex-wrap: wrap;
            margin: 6/@vv 0;
            // transform: scale(0.5);
            // transform-origin: left 0;

          }
          .prices-box {
            min-height: 14/@vv;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // margin-top: -17/@vv;

            .tags {
              font-size: 10/@vv;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 14/@vv;
              box-sizing: border-box;
              padding-left: 7/@vv;
              padding-right: 8/@vv;
              border-right: 1/@vv solid #979797;
              // margin-right: 7/@vv;

              &:first-child {
                padding-left: 0;
              }

              &:last-child {
                border-right: none;
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
